import React from 'react';
import { GiftIcon } from 'lucide-react';
import { bonos } from '../data/content';

// Los mockups son PNG grandes: pedimos una versión reducida y comprimida al CDN
// para aligerar la carga de la página.
function optimizedSrc(url: string, width: number): string {
  const separator = url.includes('?') ? '&' : '?';
  return `${url}${separator}width=${width}&quality=60&format=webp`;
}
export function BonosSection() {
  return <section className="w-full border-y border-ink-800 bg-ink-900 py-20" aria-labelledby="bonos" style={{
    paddingTop: "35px",
    paddingBottom: "35px"
  }} data-id="element-14" data-mp="tgj7dqdzq6hs">
      <div className="mx-auto w-full max-w-6xl px-4 sm:px-6" data-id="element-15" data-mp="kf1sucg8ecv7">
        <div data-id="element-16" data-mp="kfboafk1pc8a">
          <p className="flex items-center gap-2 font-display text-[11px] font-700 uppercase tracking-[0.28em] text-gold" data-id="element-17" data-mp="kh60n5h93w0r">
            <GiftIcon className="h-4 w-4" aria-hidden="true" data-id="element-18" data-mp="2est2vd2h2yr6" />
            5 Bonos estratégicos
          </p>
          <h2 id="bonos" className="mt-3 max-w-2xl font-display text-3xl font-900 leading-tight text-white sm:text-4xl" data-id="element-19" data-mp="29tgh6vnc7xq6">
            Siempre incluidos — activan el sistema desde el día uno
          </h2>
        </div>

        <ul className="mt-10 grid gap-4 md:grid-cols-2 lg:grid-cols-3" data-id="element-20" data-mp="vvk8188t9mpu">
          {bonos.map(bono => <li key={bono.number} className="flex flex-col rounded-xl border border-ink-800 bg-ink-950 p-6" data-id="element-21" data-mp="hvhvm1j9vlhz">
              <span className="font-display text-3xl font-900 leading-none text-ink-600" data-id="element-22" data-mp="muuds8z784e8">
                {bono.number}
              </span>
              {bono.image && <img src={optimizedSrc(bono.image, 320)} srcSet={`${optimizedSrc(bono.image, 220)} 220w, ${optimizedSrc(bono.image, 320)} 320w`} sizes="(min-width: 1024px) 180px, (min-width: 768px) 200px, 45vw" alt={`Mockup del bono ${bono.number}: ${bono.title}`} className={`mt-4 h-auto rounded-lg bg-white object-contain ${bono.imageSize === 'half' ? 'w-1/2' : 'w-full'}`} width={320} height={320} loading="lazy" decoding="async" data-id="element-23" data-mp="1ekz7wzcrg5sn" />}
              <h3 className="mt-4 font-display text-lg font-800 leading-snug text-white" data-id="element-24" data-mp="1y97xr2qtzzoz">
                {bono.title}
              </h3>
              <p className="mt-3 text-sm leading-relaxed text-slate-400" data-id="element-25" data-mp="2846sde4x0hbc">{bono.description}</p>
              <p className="mt-auto flex items-baseline gap-2 pt-5" data-id="element-26" data-mp="236n4dmif0q67">
                <span className="text-sm text-slate-500 line-through" data-id="element-27" data-mp="1y5r2tfljdg3y">{bono.price}</span>
                <span className="font-display text-sm font-800 uppercase tracking-wide text-leaf-400" data-id="element-28" data-mp="1t8h4tbk2zw4i">
                  Gratis
                </span>
              </p>
            </li>)}

          <li className="flex flex-col justify-center rounded-xl border border-gold bg-ink-800 p-6" data-id="element-29" data-mp="1kfniwva4pyho">
            <p className="text-xs font-600 uppercase tracking-[0.2em] text-slate-300" data-id="element-30" data-mp="1ffrgv1kzsh4r">
              Valor total de los 5 bonos
            </p>
            <p className="mt-2 flex flex-wrap items-baseline gap-3" data-id="element-31" data-mp="1airccv3sjmfr">
              <span translate="no" className="whitespace-nowrap font-display text-4xl font-900 text-slate-500 line-through" data-id="element-32" data-mp="15id4bd26wchq">
                $89&nbsp;USD
              </span>
              <span className="font-display text-4xl font-900 uppercase text-leaf-400" data-id="element-33" data-mp="3d451mvit9875">Gratis</span>
            </p>
            <p className="mt-3 text-sm leading-relaxed text-slate-200" data-id="element-34" data-mp="3h4ozk1b7kfuc">
              Incluidos con tu Código Solar 360°
            </p>
          </li>
        </ul>
      </div>
    </section>;
}